import type { UserGroup } from '../model/types.tsx';
import { toItem } from '../rest/fetch.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformFromStateValue = (stateValue: UserGroup | null): any =>
	stateValue && toItem(stateValue);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformToStateValue = (value: any): UserGroup => value && { name: value.value };
